import { render, staticRenderFns } from "./AManagementSummary.vue?vue&type=template&id=6ebfb634&scoped=true&"
import script from "./AManagementSummary.vue?vue&type=script&lang=ts&"
export * from "./AManagementSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AManagementSummary.vue?vue&type=style&index=0&id=6ebfb634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfb634",
  null
  
)

export default component.exports